module.exports = __webpack_public_path__ + "static/pumps_food_process-3f92635ea0a1fdc99030cf1abdb9cacc.png";